/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
  "/api/v1": {
    get: operations["AppController_home"];
  };
  "/api/v1/me": {
    get: operations["AppController_me"];
  };
  "/api/v1/shops/{shop}": {
    get: operations["AppController_ensureShops"];
  };
  "/api/v1/users/{firebaseUserId}": {
    post: operations["UserController_updateUser"];
  };
  "/api/v1/users/{firebaseUserId}:beginUploadAvatar": {
    post: operations["UserController_beginUploadAvatar"];
  };
  "/api/v1/product-reviews:beginUploadProductReviewVideo": {
    post: operations["ProductReviewController_beginUploadProductReviewVideo"];
  };
  "/api/v1/product-reviews:createProductReviewVideo": {
    post: operations["ProductReviewController_createProductReviewVideo"];
  };
  "/api/v1/product-reviews/{reviewId}:updateProductReviewVideo": {
    post: operations["ProductReviewController_updateProductReviewVideo"];
  };
  "/api/v1/product-reviews/{reviewId}:removeProductReviewVideo": {
    post: operations["ProductReviewController_removeProductReviewVideo"];
  };
  "/shopify/verify-shop-authorization": {
    /** Shopify OAuth endpoint */
    get: operations["ShopifyOAuthController_verifyShopAuthorization"];
  };
  "/shopify/handle-authorization-callback": {
    /** Shopify OAuth callback */
    get: operations["ShopifyOAuthController_handleAuthorizationCallback"];
  };
  "/shopify/customer-auth": {
    post: operations["AuthController_customerAuth"];
  };
  "/shopify/admin-auth": {
    post: operations["AuthController_adminAuth"];
  };
  "/shops/{shop}:isEmailRegistered": {
    post: operations["AuthController_isEmailRegistered"];
  };
  "/api/v1/shopify/products/count": {
    get: operations["ShopifyApiController_countProducts"];
  };
}

export interface components {
  schemas: {
    UpdateUserRequest: {
      /** @description optional: username to use */
      username?: string;
      /** @description optional: set avatar from image url, can be external or uploaded to firebase storage */
      avatarUrl?: string;
    };
    UserProfileResponse: {
      mappedEmail: string;
      shop: string;
      uid: string;
      avatar?: string;
      username: string;
      /** @example 2021-08-09T00:45:02.508Z */
      createdAt: string;
      /** @example 2021-08-09T00:45:02.508Z */
      updatedAt: string;
    };
    BeginUploadAvatarResponse: {
      id: string;
      uploadUrl: string;
    };
    BeginUploadProductReviewVideoRequest: {
      maxDurationSeconds: number;
    };
    BeginUploadProductReviewVideoResponse: {
      id: string;
      uploadUrl: string;
    };
    CreateProductReviewVideoRequest: {
      videoId: string;
      productId?: string;
      caption?: string;
      reactionCode?: string;
    };
    StreamDetailStatus: {
      state: string;
      pctComplete?: string;
      errorReasonCode?: string;
      errorReasonText?: string;
    };
    StreamDimention: {
      width: number;
      height: number;
    };
    StreamDetailPlayback: {
      hls: string;
      dash: string;
    };
    StreamDetailPublicDetails: {
      title?: string;
      share_link?: string;
      channel_link?: string;
      logo?: string;
    };
    StreamDetailResponse: {
      uid: string;
      creator?: { [key: string]: unknown };
      thumbnail: string;
      thumbnailTimestampPct: number;
      readyToStream: boolean;
      status: components["schemas"]["StreamDetailStatus"];
      meta: { [key: string]: unknown };
      created: string;
      modified: string;
      size: number;
      preview: string;
      allowedOrigins?: string[];
      requireSignedURLs: boolean;
      uploaded: string;
      uploadExpiry?: { [key: string]: unknown };
      maxSizeBytes?: { [key: string]: unknown };
      maxDurationSeconds?: { [key: string]: unknown };
      duration: number;
      input: components["schemas"]["StreamDimention"];
      playback: components["schemas"]["StreamDetailPlayback"];
      watermark?: { [key: string]: unknown };
      clippedFrom?: { [key: string]: unknown };
      publicDetails?: components["schemas"]["StreamDetailPublicDetails"];
    };
    ProductReviewVideoResponse: {
      id: string;
      type: string;
      details: components["schemas"]["StreamDetailResponse"];
      caption?: string;
      reactionCode?: string;
      reviewerId: string;
      productId?: string;
      /** @example 2021-08-09T00:45:02.508Z */
      createdAt: string;
      /** @example 2021-08-09T00:45:02.508Z */
      updatedAt: string;
    };
    UpdateProductReviewVideoRequest: {
      videoId?: string;
      productId?: string;
      caption?: string;
      reactionCode?: string;
    };
    OAuthResponse: {
      authorized: boolean;
      clientId: string;
      scope: string;
      nonce: string;
    };
    OAuthCallbackOfflineTokenResponse: {
      client_id: string;
      shop: string;
    };
    OAuthTokenAssociatedUser: {
      id: number;
      first_name: string;
      last_name: string;
      email: string;
      email_verified: boolean;
      account_owner: boolean;
      locale: string;
      collaborator: boolean;
    };
    OAuthCallbackOnlineTokenResponse: {
      info: components["schemas"]["OAuthTokenAssociatedUser"];
      custom_token: string;
    };
    CustomerAuthRequest: {
      shop: string;
      customerAccessToken: string;
    };
    CustomerAuthInfo: {
      id: string;
      email: string;
      phone?: string;
      firstName?: string;
      lastName?: string;
      acceptsMarketing: boolean;
    };
    CustomerAuthResponse: {
      info: components["schemas"]["CustomerAuthInfo"];
      custom_token: string;
    };
    AdminAuthInfo: {
      id: string;
      email: string;
    };
    AdminAuthResponse: {
      info: components["schemas"]["AdminAuthInfo"];
      custom_token: string;
    };
    IsEmailRegisteredRequest: {
      email: string;
    };
    ProductCountResponse: {
      count: number;
    };
  };
}

export interface operations {
  AppController_home: {
    parameters: {};
    responses: {
      200: unknown;
    };
  };
  AppController_me: {
    parameters: {};
    responses: {
      200: unknown;
    };
  };
  AppController_ensureShops: {
    parameters: {
      path: {
        shop: unknown;
      };
    };
    responses: {
      200: unknown;
    };
  };
  UserController_updateUser: {
    parameters: {
      path: {
        firebaseUserId: unknown;
      };
    };
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["UserProfileResponse"];
        };
      };
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["UpdateUserRequest"];
      };
    };
  };
  UserController_beginUploadAvatar: {
    parameters: {
      path: {
        firebaseUserId: unknown;
      };
    };
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["BeginUploadAvatarResponse"];
        };
      };
    };
  };
  ProductReviewController_beginUploadProductReviewVideo: {
    parameters: {};
    responses: {
      201: {
        content: {
          "application/json": components["schemas"]["BeginUploadProductReviewVideoResponse"];
        };
      };
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["BeginUploadProductReviewVideoRequest"];
      };
    };
  };
  ProductReviewController_createProductReviewVideo: {
    parameters: {};
    responses: {
      201: {
        content: {
          "application/json": components["schemas"]["ProductReviewVideoResponse"];
        };
      };
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["CreateProductReviewVideoRequest"];
      };
    };
  };
  ProductReviewController_updateProductReviewVideo: {
    parameters: {
      path: {
        reviewId: string;
      };
    };
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["ProductReviewVideoResponse"];
        };
      };
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["UpdateProductReviewVideoRequest"];
      };
    };
  };
  ProductReviewController_removeProductReviewVideo: {
    parameters: {
      path: {
        reviewId: string;
      };
    };
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["ProductReviewVideoResponse"];
        };
      };
    };
  };
  /** Shopify OAuth endpoint */
  ShopifyOAuthController_verifyShopAuthorization: {
    parameters: {};
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["OAuthResponse"];
        };
      };
    };
  };
  /** Shopify OAuth callback */
  ShopifyOAuthController_handleAuthorizationCallback: {
    parameters: {};
    responses: {
      200: {
        content: {
          "application/json": Partial<
            components["schemas"]["OAuthCallbackOfflineTokenResponse"]
          > &
            Partial<components["schemas"]["OAuthCallbackOnlineTokenResponse"]>;
        };
      };
    };
  };
  AuthController_customerAuth: {
    parameters: {};
    responses: {
      201: {
        content: {
          "application/json": components["schemas"]["CustomerAuthResponse"];
        };
      };
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["CustomerAuthRequest"];
      };
    };
  };
  AuthController_adminAuth: {
    parameters: {
      header: {
        Authorization: string;
      };
    };
    responses: {
      201: {
        content: {
          "application/json": components["schemas"]["AdminAuthResponse"];
        };
      };
    };
  };
  AuthController_isEmailRegistered: {
    parameters: {
      path: {
        shop: string;
      };
    };
    responses: {
      201: {
        content: {
          "application/json": boolean;
        };
      };
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["IsEmailRegisteredRequest"];
      };
    };
  };
  ShopifyApiController_countProducts: {
    parameters: {};
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["ProductCountResponse"];
        };
      };
    };
  };
}

export interface external {}

export namespace ApiPaths {
  export const AppController_home = {
    url: "/api/v1" as const,
    method: "get" as const,
  };
  export const AppController_me = {
    url: "/api/v1/me" as const,
    method: "get" as const,
  };
  export const AppController_ensureShops = {
    url: "/api/v1/shops/{shop}" as const,
    method: "get" as const,
  };
  export const UserController_updateUser = {
    url: "/api/v1/users/{firebaseUserId}" as const,
    method: "post" as const,
  };
  export const UserController_beginUploadAvatar = {
    url: "/api/v1/users/{firebaseUserId}:beginUploadAvatar" as const,
    method: "post" as const,
  };
  export const ProductReviewController_beginUploadProductReviewVideo = {
    url: "/api/v1/product-reviews:beginUploadProductReviewVideo" as const,
    method: "post" as const,
  };
  export const ProductReviewController_createProductReviewVideo = {
    url: "/api/v1/product-reviews:createProductReviewVideo" as const,
    method: "post" as const,
  };
  export const ProductReviewController_updateProductReviewVideo = {
    url: "/api/v1/product-reviews/{reviewId}:updateProductReviewVideo" as const,
    method: "post" as const,
  };
  export const ProductReviewController_removeProductReviewVideo = {
    url: "/api/v1/product-reviews/{reviewId}:removeProductReviewVideo" as const,
    method: "post" as const,
  };
  export const ShopifyOAuthController_verifyShopAuthorization = {
    url: "/shopify/verify-shop-authorization" as const,
    method: "get" as const,
  };
  export const ShopifyOAuthController_handleAuthorizationCallback = {
    url: "/shopify/handle-authorization-callback" as const,
    method: "get" as const,
  };
  export const AuthController_customerAuth = {
    url: "/shopify/customer-auth" as const,
    method: "post" as const,
  };
  export const AuthController_adminAuth = {
    url: "/shopify/admin-auth" as const,
    method: "post" as const,
  };
  export const AuthController_isEmailRegistered = {
    url: "/shops/{shop}:isEmailRegistered" as const,
    method: "post" as const,
  };
  export const ShopifyApiController_countProducts = {
    url: "/api/v1/shopify/products/count" as const,
    method: "get" as const,
  };
}
